import { useT } from '../../i18n';
import type { KhoaDich } from '../../i18n';
import { usePhamVi } from '../../hooks/usePhamVi';
import { useAuthStore } from '../../stores/auth';
import type { TenantStatus } from '../../modules/tenant/types';

/**
 * Câu báo theo trạng thái tenant.
 *
 * - `SUSPENDED`, `ARCHIVED`: từ ADR-0077 Gateway chặn cả quản trị tổ chức, nên
 *   băng chỉ hiện trong khoảnh khắc tổ chức vừa đổi trạng thái mà cổng chưa tải
 *   lại quyền; lần tải sau nhận `403 TENANT_SUSPENDED` và `NguCanhGate` thay cả
 *   cổng bằng màn chặn.
 * - `DELETED` không tới được đây vì Gateway chặn mọi người.
 */
const CAU_THEO_TRANG_THAI: Partial<Record<TenantStatus, KhoaDich>> = {
  SUSPENDED: 'nguCanh.bangTamNgung',
  ARCHIVED: 'nguCanh.bangLuuTru',
};

/**
 * Băng báo đầu vùng nội dung, ở mọi màn của cổng tenant, khi tổ chức đang tạm
 * ngưng hoặc đã lưu trữ.
 *
 * Dính ở đầu `<main>`
 * (khối cuộn duy nhất của khung) để cuộn tới đâu cũng còn thấy.
 *
 * Không hiện ở dữ liệu mẫu và nhân sự nền tảng: `trangThaiTenant` chỉ có khi
 * `me/context` thật trả về (`useNguCanhCuaToi`); bản mẫu luôn là `ACTIVE`.
 * Cùng bậc màu `warning` với dải "Tạm ngưng từ…" ở màn chi tiết tenant.
 */
export function BangTamNgungToChuc() {
  const { t } = useT();
  const phamVi = usePhamVi();
  const trangThai = useAuthStore((s) => s.user?.trangThaiTenant);

  const khoa = trangThai ? CAU_THEO_TRANG_THAI[trangThai] : undefined;
  if (phamVi !== 'tenant' || !khoa) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-10 border-b border-warning-200 bg-warning-50 px-6 py-3 text-sm text-warning-700"
    >
      {t(khoa)}
    </div>
  );
}
